import { useSessionStorage } from 'usehooks-ts';
import { isEmpty } from 'lodash';

import { RecordsWithTimestamp } from '@app/components';
import { storageKeys } from '@app/constants';

import { UserSearchDto } from '../useRecentActivityRequests';
import {
  useSaveSavedInstancesMutation,
  useSaveSavedSearchesMutation,
} from '../useSavedActivityRequests';

export const useSavedActivityTransfer = () => {
  const [savedGuestSearches, setSavedGuestSearches] = useSessionStorage<
    UserSearchDto[]
  >(storageKeys.savedSearches, []);
  const [savedInstances, setSavedInstances] = useSessionStorage<
    RecordsWithTimestamp[]
  >(storageKeys.savedInstances, []);

  const transferSavedRecordsMutation = useSaveSavedInstancesMutation();
  const transferSavedSearchesMutation = useSaveSavedSearchesMutation();

  const transferSavedActivity = (systemId: string) => {
    if (!isEmpty(savedInstances)) {
      transferSavedRecordsMutation.mutate(
        {
          savedInstances,
          systemId,
        },
        { onSuccess: () => setSavedInstances([]) }
      );
    }

    if (!isEmpty(savedGuestSearches)) {
      transferSavedSearchesMutation.mutate(
        {
          searches: savedGuestSearches,
          systemId,
        },
        { onSuccess: () => setSavedGuestSearches([]) }
      );
    }
  };

  return {
    isLoading:
      transferSavedSearchesMutation.isLoading ||
      transferSavedRecordsMutation.isLoading,
    transfer: transferSavedActivity,
  };
};
